import React, {useMemo} from 'react';
import {Handle, NodeProps, Position} from 'reactflow';
import {useTranslation} from 'react-i18next';
import {QuestionNodeData} from '../nodes.types';

function QuestionNode({data}: NodeProps<QuestionNodeData>): JSX.Element {
    const {element} = data;
    const {t} = useTranslation();

    const answers = useMemo(() => {
        return element.answers?.map((answer, index) => ({text: answer.text, index})) ?? [];
    }, [element]);

    return (
        <div className="rf-question-node">
            <Handle type="target" isConnectable={false} position={Position.Left} id="from-slide" />

            <div className="rf-question-node__header">
                <span className="rf-question-node__type-badge">{t('presEditPage.rules.question')}</span>
                <p className="rf-question-node__question">{element.question}</p>
            </div>

            <ul className="rf-question-node__answers">
                {answers.map((answer) => (
                    <li key={answer.index} className="rf-question-node__answer-row">
                        <span className="rf-question-node__answer-index">{answer.index + 1}</span>
                        <span className="rf-question-node__answer-text" title={answer.text}>
                            {answer.text}
                        </span>
                        <Handle
                            type="source"
                            position={Position.Right}
                            id={`answer-${answer.index}`}
                            className="rf-question-node__answer-handle"
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default QuestionNode;
